import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')

export const GOODS_REMAINING_LIST_PAGE_NAME = 'cabinet:goods-remaining'
// URLs
export const GOODS_REMAINING_LIST_PAGE_URL = ''

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(GOODS_REMAINING_LIST_PAGE_URL, list, GOODS_REMAINING_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'goods-remaining',
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
